import { render, staticRenderFns } from "./ModalMessageResponseDetails.vue?vue&type=template&id=254f898a&scoped=true"
import script from "./ModalMessageResponseDetails.vue?vue&type=script&lang=js"
export * from "./ModalMessageResponseDetails.vue?vue&type=script&lang=js"
import style0 from "./ModalMessageResponseDetails.vue?vue&type=style&index=0&id=254f898a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254f898a",
  null
  
)

export default component.exports